import { CASES } from '../EnumTypes/ActionEnumTypes';
import { getCaseDetails as getCaseDetailsConnector } from 'Connectors/CaseConnector';
import * as ViewManagementModule from 'Modules/ViewManagementModule';

const init = () => ({
  type: CASES.GET_CASE_DETAILS_INIT,
});

const success = (caseDetails) => ({
  type: CASES.GET_CASE_DETAILS_SUCCESS,
  payload: {
    caseDetails,
  },
});

const failure = () => ({
  type: CASES.GET_CASE_DETAILS_FAILURE,
});

const getCaseDetails = (id) => async (dispatch) => {
  dispatch(init());
  try {
    dispatch(ViewManagementModule.Actions.showLoader());
    const { data } = await getCaseDetailsConnector(id);
    dispatch(success(data));
    dispatch(ViewManagementModule.Actions.hideLoader());
  } catch (err) {
    dispatch(ViewManagementModule.Actions.hideLoader());
    dispatch(failure());
  }
};

export default getCaseDetails;
